import React from "react";
import { toElementProps } from "../../Element";
import Button, { ButtonStyles } from "./Button.jsx";

export function MenuActionsStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .menu-actions:not(.mobile)": {
            [MobileBreakpoint]: {
                display: "none !important",
            },
        },

        "& .menu-actions.mobile": {
            display: "grid",
            gridAutoFlow: "dense",
            gridGap: "32px",
            paddingTop: "20px",
        },

        ...ButtonStyles(params),
    };
}

export default function MenuActions(props) {
    const { Actions, ProductType, variables2block } = props.variables;
    let _Actions = Actions;

    if (ProductType === "Custom") {
        for (const element of variables2block) {
            if (element.name === "BlockHeader") {
                _Actions = element.variables.Actions;
                break;
            }
        }
    }

    if (!Array.isArray(_Actions)) {
        console.warn("Menu actions is not array!");
        return null;
    }

    const CNMenuActions = ["menu-actions"];
    props.mobile && CNMenuActions.push("mobile");
    const elProps = toElementProps(props, { className: CNMenuActions });
    return <div {...elProps}>{_Actions && _Actions.map((action, index) => <Button key={index} {...action} />)}</div>;
}
